import { About } from './Components/About/About';
import { Benefits } from './Components/Benifits/Benefits';
import { Contact } from './Components/Contact/Contact';
import { DownloadApp } from './Components/DownloadApp/DownloadApp';
import { FinalCTA } from './Components/FinalCTA/FinalCTA';
import { Footer } from './Components/Footer/Footer';
import { Header } from './Components/Header/Header';
import { Navbar } from './Components/Header/Navbar/Navbar';
import { Instructor } from './Components/Instructor/Instructor';
import { MCQ } from './Components/MCQ/MCQ';
import { Outcome } from './Components/Outcome/Outcome';
import { Positioning } from './Components/Positioning/Positioning';
import { Pricing } from './Components/Pricing/Pricing';
import { Structure } from './Components/Structure/Structure';
import { Subjects } from './Components/Subjects/Subjects';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Subjects />
      <Structure />
      <Benefits />
      <About />
      <MCQ />
      <DownloadApp />
      <Outcome />
      <Positioning />
      <Instructor />
      <Pricing />
      <FinalCTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
